import { KeyValue, NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { ButtonModule, ListGroupModule, PopoverModule } from '@coreui/angular';
import { IconModule } from '@coreui/icons-angular';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export type MenuPlacement = 'top' | 'bottom' | 'left' | 'right';
export interface ICustomActionMenu {
  onMenuItemClick: (
    menuKey: string,
    params: ICellRendererParams & ICustomActionMenu
  ) => void;
  menuPlacement?: MenuPlacement;
}

@Component({
  selector: 'smarsh-aggrid-custom-action-menu',
  standalone: true,
  imports: [PopoverModule, ButtonModule, IconModule, ListGroupModule, NgFor],
  templateUrl: './aggrid-custom-action-menu.component.html',
  styles: `
    .menu-icon {
      text-decoration: none;
      cursor: pointer;
    }
  `
})
export class AggridCustomActionMenuComponent
  implements ICellRendererAngularComp
{
  params!: ICellRendererParams & ICustomActionMenu;
  menuList!: KeyValue<string, string>[];
  menuPlacement!: MenuPlacement;

  agInit(params: ICellRendererParams & ICustomActionMenu): void {
    this.params = params;
    this.menuList = params.value;
    this.menuPlacement = params.menuPlacement ? params.menuPlacement : 'bottom';
  }
  refresh(params: ICellRendererParams & ICustomActionMenu): boolean {
    this.params = params;
    this.menuList = params.value;
    return true;
  }

  onClick(key: string) {
    this.params.onMenuItemClick(key, this.params);
  }
}
